import React from 'react';
import { useSelector } from 'react-redux';
import Heading from '../../components/Heading';
import Tabs from '../../components/Tabs';
import EmailTemplatesTable from '../../components/EmailTemplatesTable';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';

const EmailTemplates = () => {
  const { emailTemplates } = useSelector((state: any) => state.emailTemplates);

  return (
    <WithNavigation
      title="Email Templates"
      top={<Heading headline="Email Templates" />}
      bottom={(
        <Tabs
          items={[
            {
              label: 'Email Templates',
              length: emailTemplates?.length || 0,
              content: <EmailTemplatesTable />
            }
          ]}
        />
      )}
    />
  );
};

export default EmailTemplates;